module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "next-up-7s.893e1a11.png";